module.exports = __webpack_public_path__ + "static/media/icon-probate-positive.3ca6c762.svg";